import { Guid } from 'Lib/Guid';
import React from 'react';
import ListDropdown from '../../../List/ListDropdown';

interface IImportTestListDropdownProps {
  maxResults?: number;
  placeholder?: string;
  worksheetId?: Guid;
  importPropertyName?: string;
  queryParams?: any;
}

const ImportTestListDropdown: React.FC<IImportTestListDropdownProps> = ({
  maxResults = 20,
  placeholder = 'Select test...',
  worksheetId = undefined,
  importPropertyName = undefined,
  queryParams = undefined,
  ...otherProps
}) => {
  return (
    <ListDropdown
      {...otherProps}
      placeholder={placeholder}
      endpoint="worksheets.importTestsList"
      queryParams={{
        worksheetId,
        importForProperty: importPropertyName,
        limit: maxResults,
        ...queryParams,
      }}
      maxResults={queryParams?.limit ?? maxResults}
    />
  );
};

export { ImportTestListDropdown };
export type { IImportTestListDropdownProps };
export default ImportTestListDropdown;
